import React from 'react';
import RectangleSkeleton from 'components/Skeletons/RectangleSkeleton';
import styles from './TransientDriversWidget.module.css';

function TitleAndValueSkeleton() {
    return (
        <div className={styles.titleAndValueSkeleton}>
            <RectangleSkeleton width="80%" height="12px" />
            <RectangleSkeleton width="60%" height="32px" />
        </div>
    );
}

function TransientDriversSkeleton() {
    return (
        <div className={styles.skeletonContainer}>
            <RectangleSkeleton width="200px" height="24px" />
            <div className={styles.highlightItems}>
                <TitleAndValueSkeleton />
                <TitleAndValueSkeleton />
                <TitleAndValueSkeleton />
                <TitleAndValueSkeleton />
            </div>

            <div className={styles.divider} style={{ margin: 0 }} />

            <RectangleSkeleton width="200px" height="24px" />

            <div className={styles.breakdownInfoContainer}>
                <TitleAndValueSkeleton />
                <TitleAndValueSkeleton />
                <TitleAndValueSkeleton />
            </div>

            <div className={styles.bars}>
                <RectangleSkeleton />
                <RectangleSkeleton />
                <RectangleSkeleton />
            </div>
        </div>
    );
}

export default TransientDriversSkeleton;
